import { twMerge } from 'tailwind-merge';

import { ReactComponent as MarkerBgSvg } from 'assets/nft-card/nft-card-market-background.svg';

import { useNftCardSize } from '../hooks';
import { useNftCardContext } from '../nftCardContext/NftCardContext';

type NftCardMarkerProps = {
  className?: string;
  markerClassName?: string;
  imageClassName?: string;
};

const NftCardMarker = ({ className, markerClassName, imageClassName }: NftCardMarkerProps) => {
  const { asset } = useNftCardContext();
  const { isCardLarge, isCardMedium, isCardSmall } = useNftCardSize();
  const isNotLargeCard = isCardMedium || isCardSmall;

  return (
    <div className={twMerge('tw-absolute tw-inset-x-0 -tw-top-15 tw-flex tw-justify-center', className)}>
      <MarkerBgSvg
        className={twMerge(isNotLargeCard && 'tw-h-20 tw-w-20', isCardLarge && 'tw-h-22 tw-w-22', markerClassName)}
      />
      <img
        className={twMerge(
          'tw-absolute tw-top-1',
          isNotLargeCard && 'tw-h-18 tw-w-18',
          isCardLarge && 'tw-h-20 tw-w-20',
          imageClassName
        )}
        src={asset?.markerUrl}
        alt=""
      />
    </div>
  );
};

export default NftCardMarker;
